export default __webpack_public_path__ + "static/media/MK.4fe58cee.ico";